export class ExtendedCustomEventData {
    constructor(data) {
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pathData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "extraData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = data.name;
        this.pathData = data.pathData || [];
        this.extraData = data.extraData;
    }
    get path() {
        return this.pathData.join('__');
    }
}
//# sourceMappingURL=CustomEventData.js.map